module.exports = __webpack_public_path__ + "img/Tour POI Icon.f1157fb5.svg";